import Main from './Main.js';

document.addEventListener('DOMContentLoaded', () => {
    new Main();
});
